import { render, staticRenderFns } from "./InteresShow.vue?vue&type=template&id=1910f40f"
import script from "./InteresShow.vue?vue&type=script&lang=js"
export * from "./InteresShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports